/**
 * Resolves OAuth scopes to a string array suitable for the FSM's `oAuthScopeSet`.
 *
 * Prefers `oAuthScopes` (array) when provided. Falls back to splitting `oAuthScope`
 * (deprecated string) on whitespace/commas.
 *
 * @param oAuthScope  - Deprecated space/comma-separated scope string.
 * @param oAuthScopes - Preferred array of scope strings.
 * @returns Resolved scope set, or `undefined` if no scopes were provided.
 */
export function resolveOAuthScopeSet(oAuthScope, oAuthScopes) {
  if (oAuthScopes !== undefined) {
    return oAuthScopes;
  }
  if (!oAuthScope) {
    return undefined;
  }
  const scopes = oAuthScope.split(/[\s,]+/).filter(Boolean);
  return scopes.length > 0 ? scopes : undefined;
}